export default "__VITE_PUBLIC_ASSET__cf305a01__"